export default {
  firstName: '',
  lastName: '',
  email: '',
  password: ''
}
